import { render, staticRenderFns } from "./MoveToFolderModal.vue?vue&type=template&id=2974f52e&scoped=true"
import script from "./MoveToFolderModal.vue?vue&type=script&lang=ts"
export * from "./MoveToFolderModal.vue?vue&type=script&lang=ts"
import style0 from "./MoveToFolderModal.vue?vue&type=style&index=0&id=2974f52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974f52e",
  null
  
)

export default component.exports